import React from 'react';
import { FaAward, FaShieldAlt, FaUserTie } from 'react-icons/fa';
import reasonImage from '../../images/ev-aletleri.jpeg';
import './ReasonPart.css';

const reasons = [
  {
    icon: <FaAward />,
    title: 'Tecrübe',
    desc: '8+ yıl sektör deneyimi. Kombi, klima ve beyaz eşyada her marka ve modelde uzman ekibimizle yanınızdayız.',
  },
  {
    icon: <FaShieldAlt />,
    title: 'Güvenilirlik',
    desc: 'Şeffaf fiyatlandırma, garantili işçilik ve memnuniyet odaklı hizmet anlayışıyla güvenle tercih ediliyoruz.',
  },
  {
    icon: <FaUserTie />,
    title: 'Profesyonellik',
    desc: 'Zamanında randevu, temiz çalışma ve yerinde hızlı çözüm. Sorunsuz bir servis deneyimi sunuyoruz.',
  },
];

const ReasonPart = () => {
  return (
    <section className="reason-part section section-muted" aria-labelledby="reason-heading">
      <div className="section-inner">
        <div className="reason-layout">
          <div className="reason-visual">
            <div className="reason-image-frame">
              <img
                className="reason-image"
                src={reasonImage}
                alt="Profesyonel teknik servis — kombi, klima ve beyaz eşya bakımı"
                loading="lazy"
              />
              <div className="reason-image-badge">
                <strong>8+</strong>
                <span>Yıl Tecrübe</span>
              </div>
            </div>
          </div>

          <div className="reason-content">
            <div className="section-header reason-header">
              <h2 id="reason-heading" className="section-title">
                Neden Üç Kardeşler Teknik Servis?
              </h2>
              <p className="section-subtitle reason-intro">
                Bursa&apos;da kombi bakımı, petek temizliği, klima servisi ve beyaz eşya tamiri
                alanlarında binlerce müşterinin güvendiği teknik servis adresi.
              </p>
            </div>

            <ul className="reason-grid">
              {reasons.map((item) => (
                <li className="reason-card" key={item.title}>
                  <span className="reason-card-icon" aria-hidden>
                    {item.icon}
                  </span>
                  <div className="reason-card-body">
                    <h3 className="reason-card-title">{item.title}</h3>
                    <p className="reason-card-desc">{item.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReasonPart;
